"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORUM_GUIDELINES_BANNER = exports.FORUM_GUIDELINES_POINTS = exports.FORUM_GUIDELINES_TITLE = void 0;
exports.FORUM_GUIDELINES_TITLE = 'ModernSea Forum guidelines';
exports.FORUM_GUIDELINES_POINTS = [
    'ModernSea Forums are a PYA membership benefit for professional discussion — not a public board.',
    'Be respectful and professional. No harassment, spam, or confidential yacht or crew information.',
    'PYA may remove comments and restrict posting in Forums. Your membership, documents, and SST access are not affected.',
    'By posting or commenting you agree to these guidelines.',
];
exports.FORUM_GUIDELINES_BANNER = 'By posting in ModernSea Forums you agree to the Forum guidelines. PYA may restrict posting without affecting your membership.';
//# sourceMappingURL=forumGuidelines.js.map